import { TraitTypes } from './types'
import { getTraitComponent } from './traits'
import { Table } from './Widgets/Table'
import { GA4Event } from '@/root/utils/common/web/gtm-events/types'

interface TraitTableProps {
  traitTable: {
    tableHeading?: {
      title: string
      trait?: TraitTypes['trait']
      textColor?: string
      onClick?: () => void
      image_url?: string
      className?: string
      tooltipTitle?: string
    }[]
    tableContent?: Array<
      | {
          columns?: Array<{
            title?: string | number
            trait?: TraitTypes['trait']
            textColor?: string
            image_url?: string
            style?: string
            className?: string
          }>
          subrows?: Array<{
            title?: string | number
            trait?: TraitTypes['trait']
            textColor?: string
            image_url?: string
            style?: string
            className?: string
          }>[]
          url?: string
          anchorTitle?: string | number
        }
      | undefined
    >
  }
  sliceLength?: number
  containerClassName?: string
  expended_label?: string
  collapsed_label?: string
  tableTitle?: string
  tableSubTitle?: string
  variant?: 'primary' | 'secondary'
  inAccordion?: boolean
  eventData?: GA4Event
  firstColumnClasses?: string
  rowClassName?: string
}

const TraitTable = ({
  traitTable,
  sliceLength,
  containerClassName = '',
  expended_label = 'See less',
  collapsed_label = 'See all',
  tableTitle,
  tableSubTitle,
  variant,
  inAccordion = false,
  eventData,
  firstColumnClasses = '',
  rowClassName = '',
}: TraitTableProps) => {
  const tableContent =
    traitTable.tableContent?.map(item => {
      return {
        ...item,
        columns: item?.columns?.map(subItem => getTraitComponent(subItem)),
        subrows: item?.subrows?.map(subItem =>
          subItem?.map(item => getTraitComponent(item)),
        ),
        anchorTitle: item?.anchorTitle ?? item?.columns?.[0]?.title ?? '',
      }
    }) ?? []

  const tableHeading =
    traitTable.tableHeading?.map(item => getTraitComponent(item)) ?? []

  const table = {
    tableHeading,
    tableContent,
    withoutOuterBorder: true,
    tableTitle,
    tableSubTitle,
  }

  return (
    <Table
      table={table}
      sliceLength={inAccordion ? traitTable.tableContent?.length : sliceLength}
      containerClassName={containerClassName}
      expended_label={expended_label}
      collapsed_label={collapsed_label}
      variant={variant}
      eventData={eventData}
      firstColumnClasses={firstColumnClasses}
      rowClassName={rowClassName}
    />
  )
}

export default TraitTable
